import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AllocationService, ProgramService } from '../../phf.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject } from 'rxjs';


@Component({
  selector: 'app-program',
  templateUrl: './program.component.html'
})
export class ProgramComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  allocations: any;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly programService: ProgramService,
    private readonly allocationService: AllocationService,
    private readonly alertDialog: CgpAlertDialogService,
  ) {
    super();
  }

  ngOnInit() {
    this.httpErrorHeader = "Program Error";
    this.filterable = "menu";
    this.sortable = true;
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.formDialog.setHeight(480);
    this.controls.excel = true;
    this.controls.delete = false;
    this.resizable = true;
    this.editForm = this.formBuilder.group({
      Id: [],
      Code: ['', Validators.required],
      IsActive: [],
      Description: [],
      ReferenceProg: [],
      AllocationID: [],
      AllocationDescription: [],
      Status: [],
      Notes: [],
      AssemblyPlant: [],
    });

    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);

    this.programService
    .pipe(takeUntil(this.ngUnsubscribe));
    this.allocationService.read()
      .then(x => this.allocations = x)
    this.dialogTitle.next('Program');
  }
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.dialogTitle.complete();
  }

  read(opts: any): Promise<any> {
    return opts.force ?
      this.programService.read('/ActiveInactivePrograms')
        .then(response => {
          response.forEach(program => {
            program.IsActiveString = program.IsActive === true ? 'Yes' : 'No';
            return program;
          });
          return response;
        })
      : Promise.resolve(this.programService.value);
  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
    const allocation = this.allocations.find(x => x.Description === 'None')
    this.editDataItem.AllocationID = allocation.Id;
    this.editDataItem.IsActive = true;
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.formDialog.next(dataItem);
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    if(dataItem.IsActive == null){
      dataItem.IsActive = true;
    }
    return isNew ?
      this.programService.save(dataItem, isNew, "", false)
      : this.programService.save(dataItem, isNew, "/" + dataItem.Id, false)
  }

  delete(dataItem: any): Promise<any> {
    return this.programService.remove('/' + dataItem.Id, false);
  }

  columns: any[] = [
    {
      field: 'Code',
      title: 'Program Code',
      sortable: true,
      filterable: true,
    },
    {
      field: 'ReferenceProg',
      title: 'Ref. Program',
      sortable: true,
      filterable: true,
    },
    {
      field: "AllocationDescription",
      title: "Allocation",
      sortable: true,
      filterable: true,
    },
    {
      field: "IsActiveString",
      title: "Is Active?",
      sortable: true,
      filterable: true,
    },
    {
      field: "Description",
      title: "Description",
      sortable: true,
      filterable: true,
      width: '*'
    },
  ]

  formControls = [
    {
      type: "text",
      name: "Code",
      title: "Program Code",
      stretch: true,
    },
    {
      type: "textarea",
      name: "Description",
      title: "Description",
      stretch: true,
    },
    {
      type: "text",
      name: "ReferenceProg",
      title: "Reference Program",
      stretch: true,
    },
    {
      name: "AllocationID",
      service: this.allocationService,
      title: "Allocation",
      stretch: true,
      type: "combobox",
      textField: "Description",
      valueField: "Id",
    },
    {
      type: "text",
      name: "AssemblyPlant",
      title: "Assembly Plant",
      stretch: true,
    },
    {
      type: "textarea",
      name: "Status",
      title: "Status",
      stretch: true,
    },
    {
      type: "textarea",
      name: "Notes",
      title: "Notes",
      stretch: true,
    },
    {
      type: "boolean",
      name: "IsActive",
      title: "Is Active?",
      stretch: true,
    },
  ]

  formDialogTabs = [
    {
      title: "Program",
      selected: true,
      formControls: this.formControls
    },
  ]
}
